import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { useTheme }, "@mui/material/Box": Box, "@mui/material/Table": Table, "@mui/material/TableBody": TableBody, "@mui/material/TableCell": TableCell, "@mui/material/TableContainer": TableContainer, "@mui/material/TableFooter": TableFooter, "@mui/material/TablePagination": TablePagination, "@mui/material/TableRow": TableRow, "@mui/material/Paper": Paper, "@mui/material/IconButton": IconButton, "@mui/icons-material/FirstPage": FirstPageIcon, "@mui/icons-material/KeyboardArrowLeft": KeyboardArrowLeft, "@mui/icons-material/KeyboardArrowRight": KeyboardArrowRight, "@mui/icons-material/LastPage": LastPageIcon } } });
export default ClientProvider;
